import script from "./Cart.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cart.vue?vue&type=script&setup=true&lang=ts"

import "./Cart.vue?vue&type=style&index=0&id=15153764&lang=css"

const __exports__ = script;

export default __exports__